
import React from 'react';
import Board from 'main/Board';

const App = ()=>{
	return (
		<Board/>
	)
}

export default App;
